import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { UIProvider } from "folksam-ui";
import log from "loglevel";

import FileSizeProvider from "providers/FileSizeProvider";
import GlobalStateProvider from "providers/GlobalStateProvider";
import trekronorTheme from "trekronorTheme";

import { BrowserRouter as Router } from "react-router-dom";

import * as serviceWorker from "./serviceWorker";
import { readApplicationConfigurationFromDOM } from "services/utils.service";

/**
 * Enable or disable logging depending on environment
 */
// if (process.env.NODE_ENV === "development") {
//   log.enableAll();
// } else {
//   log.disableAll();
// }

const applicationSettings = readApplicationConfigurationFromDOM(
  "application-settings"
);

ReactDOM.render(
  <UIProvider theme={{ theme: trekronorTheme }}>
    <GlobalStateProvider>
      <FileSizeProvider>
        <Router basename={applicationSettings.baseUrl}>
          <App applicationSettings={applicationSettings} />
        </Router>
      </FileSizeProvider>
    </GlobalStateProvider>
  </UIProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
